import React, { useState } from 'react'
import Merchandise from './Merchandise'
import { Container, Button, Icon, Form, FormGroup, FormField, Input, Checkbox, Divider, Menu, MenuItem, Header } from 'semantic-ui-react'

const Package = ({ game, savedDict, onStateChange }) => {
    const [activeItem, setActiveItem] = useState('resellers')
    const [name, setName] = useState(savedDict?.name || '')
    const [supplierPackageName, setSupplierPackageName] = useState(savedDict?.supplierPackageName || '')
    const [description, setDescription] = useState(savedDict?.description || '')
    const [remarks, setRemarks] = useState(savedDict?.remarks || '')
    const [isHidden, setIsHidden] = useState(savedDict?.isHidden || false)
    const [gameItems, setGameItems] = useState(savedDict?.gameItems || [])
    const [isOutOfStock, setIsOutOfStock] = useState(savedDict?.isOutOfStock || false)
    const [markupConsumer, setMarkupConsumer] = useState(savedDict?.markupConsumer || 0)

    const getDict = ({ updatedField, toggledField, updatedGameItems } = {}) => {
        return { 
            isOutOfStock: toggledField?.name === 'isOutOfStock' ? toggledField.checked : isOutOfStock,
            isHidden: toggledField?.name === 'isHidden' ? toggledField.checked : isHidden,
            name: updatedField?.name === 'name' ? updatedField.value : name,
            supplierPackageName: updatedField?.name === 'supplierPackageName' ? updatedField.value : supplierPackageName,
            description: updatedField?.name === 'description' ? updatedField.value : description,
            remarks: updatedField?.name === 'remarks' ? updatedField.value : remarks,
            markupConsumer: updatedField?.name === 'markupConsumer' ? (Number(updatedField.value) || 0) : markupConsumer,
            gameItems: updatedGameItems || gameItems
        }
    }

    const handleChangeField = e => {
        const { name, value } = e.target
        if (name === 'name') setName(value)
        if (name === 'supplierPackageName') setSupplierPackageName(value)
        if (name === 'description') setDescription(value)
        if (name === 'remarks') setRemarks(value)
        if (name === 'markupConsumer') setMarkupConsumer(Number(value) || 0)
        onStateChange(getDict({ updatedField: { name, value } }))
    }

    const handleToggle = (e, data) => {
        if (data.name === 'isOutOfStock') setIsOutOfStock(data.checked)
        if (data.name === 'isHidden') setIsHidden(data.checked)
        onStateChange(getDict({ toggledField: { name: data.name, checked: data.checked } }))
    }

    const handleMenuItemClicked = e => {
        switch (e.target.innerText) {
            case 'Consumers':
                setActiveItem('consumers')
                break
            case 'Resellers':
                setActiveItem('resellers')
                break
            default:
                break
        }
    }

    const handleMerchandiseEditGameItems = updatedGameItems => {
        setGameItems(updatedGameItems)
        onStateChange(getDict({ updatedGameItems }))
    }

    const handleOptimiseSortingClicked = () => {
        const sortedArr = [...gameItems]
        sortedArr.sort((a, b) => {
            const numA = a.nameReseller.match(/\d+/)?.[0]
            const numB = b.nameReseller.match(/\d+/)?.[0]
            if (!numA && !numB) {
                return a.nameReseller.localeCompare(b.nameReseller)
            }
            if (!numA && numB) {
                return -1
            }
            if (numA && !numB) {
                return 1
            }
            return Number(numA) - Number(numB)
        })
        setGameItems(sortedArr)
        onStateChange(getDict({ updatedGameItems: sortedArr }))
    }

    return (
        <Container inverted style={{ background: '#1b1c1d', padding: '20px' }}>
            <h3 style={{ color: 'white' }}>{name || savedDict?.name}</h3>
            <Form inverted style={{ marginTop: 25 }}>
                <FormGroup>
                    <FormField control={Checkbox} label='Is Out of Stock' name='isOutOfStock' checked={isOutOfStock} onChange={handleToggle} inverted/>
                    <FormField control={Checkbox} label='Is Hidden' name='isHidden' checked={isHidden} onChange={handleToggle} inverted/>
                </FormGroup>
                <FormGroup style={{ marginTop: 25 }} widths='equal'>
                    <FormField control={Input} label='Name' name='name' value={name} placeholder='name' onChange={handleChangeField} inverted className="dark-theme-input"/>
                    <FormField control={Input} label='Supplier Name' name='supplierPackageName' value={supplierPackageName} placeholder='Supplier Package Name' onChange={handleChangeField} inverted className="dark-theme-input"/>
                </FormGroup>
                <FormField control={Input} label='Markup % for consumer' name='markupConsumer' value={markupConsumer} placeholder='Markup % for consumer' onChange={handleChangeField} inverted className="dark-theme-input"/>
                <FormField control={Input} label='Description' name='description' value={description} placeholder='Description' onChange={handleChangeField} inverted className="dark-theme-input"/>
                <FormField control={Input} label='Remarks' name='remarks' value={remarks} placeholder='Remarks' onChange={handleChangeField} inverted className="dark-theme-input"/>
            </Form>
            <Divider inverted style={{ marginTop: 50 }} horizontal><Header inverted as="h4"><Icon inverted name="gem" />Merchandise</Header></Divider>
            <Menu inverted pointing secondary size='big'>
                <MenuItem name='Resellers' active={activeItem === 'resellers'} onClick={handleMenuItemClicked}/>
                <MenuItem name='Consumers' active={activeItem === 'consumers'} onClick={handleMenuItemClicked}/>
            </Menu>
            <Button inverted style={{ marginTop: 10 }} size='small' onClick={handleOptimiseSortingClicked}><Icon name='sort amount down'/>Optimise Sorting</Button>
            <Merchandise comeFromPackage game={game} viewMode={activeItem} savedDict={{ gameItems }} onEdit={handleMerchandiseEditGameItems}/>
        </Container>
    )
}

export default Package